var exports = {
  "kL": "BaseAvatar.module__container___bjlBWm",
  "vk": "BaseAvatar.module__clickable___bjlBWm",
  "Lw": "BaseAvatar.module__overlay___bjlBWm",
  "Sl": "BaseAvatar.module__image___bjlBWm",
  "qf": "BaseAvatar.module__placeholder___bjlBWm",
  "ci": "BaseAvatar.module__placeholderFastFade___bjlBWm",
  "Ap": "BaseAvatar.module__placeholderVisible___bjlBWm",
  "uR": "BaseAvatar.module__placeholderHidden___bjlBWm",
  "n_": "BaseAvatar.module__hoverOverlay___bjlBWm",
  "II": "BaseAvatar.module__statusContainer___bjlBWm",
  "mH": "BaseAvatar.module__statusTooltipDisabled___bjlBWm",
  "VN": "BaseAvatar.module__reducedMotion___bjlBWm",
  "BC": "BaseAvatar.module__animatedMaskShape___bjlBWm",
  "Qb": "BaseAvatar.module__animatedMaskReducedMotion___bjlBWm",
  "AP": "BaseAvatar.module__typingBubble___bjlBWm",
  "y5": "BaseAvatar.module__typingDots___bjlBWm",
  "BI": "BaseAvatar.module__typingDot___bjlBWm",
  "fQ": "BaseAvatar.module__customStatusBadge___bjlBWm",
  "Bp": "BaseAvatar.module__customStatusBadgeBackground___bjlBWm",
  "Go": "BaseAvatar.module__customStatusBadgeContent___bjlBWm",
};

module.exports = exports;
